import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { Filter, Measurement, MeasureService, MSorting } from '../http/meas-service';

export default class MeasurementStore {
    _measurements: Measurement[] = [];
    _filter: Filter = {};
    _loading = false;

    constructor() {
        makeObservable<MeasurementStore, '_loading' | '_measurements'>(this, {
            _loading: observable,
            _measurements: observable,
            loading: computed,
            measurements: computed,
            setFilter: action,
        });
    }

    get loading(): boolean {
        return this._loading;
    }

    get measurements(): Measurement[] {
        return this._measurements;
    }

    get filter(): Filter {
        return this._filter;
    }

    async setFilter(filter: Filter) {
        this._filter = filter;
        await this.load();
    }

    private async load() {
        runInAction(() => {
            this._loading = true;
        });
        try {
            const order: MSorting = { column: 'measure', order: 'asc' };
            const answer = await MeasureService.getMeasures(this._filter, order);
            runInAction(() => {
                this._measurements = answer.data;
            });
        } catch (e) {
            throw e;
        } finally {
            runInAction(() => {
                this._loading = false;
            });
        }
    }
}
